// import case names
import { updateCheckoutState, clearCheckoutState } from 'store/actions/updateCheckoutState';
import { REDUCER } from 'constants/entity-names';
import { get, set, castArray, isArray, uniq } from 'lodash';

// local dependency
import { getStore } from 'store';

// get store
const store = getStore();

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { checkoutStateResolver } from 'resolvers/checkoutState';
 */
export const addRxToCheckoutState = ( { memberId, rxId } ) => {

    // get ongoing call info from the redux store
    const checkoutState = store.getState()[ REDUCER.CHECKOUT_STATE ];

    // get the previously stored id's
    const previouslyStoredRxId = get( checkoutState, 'rxIds', [] );

    // form a unique combined list
    const combinedList = isArray( rxId ) ? [ ...rxId, ...previouslyStoredRxId ] : [ ...castArray( rxId ), ...previouslyStoredRxId ];
    const uniqueList = uniq( combinedList );

    // add `rxIds` and `memberId` to checkout state
    set( checkoutState, 'rxIds', uniqueList );
    set( checkoutState, 'memberId', memberId );

    return store.dispatch( updateCheckoutState( checkoutState ) );

};

export const updateRxState = ( { memberId, rxId } ) => {

    // get ongoing call info from the redux store
    const checkoutState = store.getState()[ REDUCER.CHECKOUT_STATE ];

    set( checkoutState, 'rxIds', uniq( rxId ) );
    set( checkoutState, 'memberId', memberId );

    return store.dispatch( updateCheckoutState( checkoutState ) );

};


/**
 * clear the checkout state from reducer
 * import { clearRxCheckoutState } from 'resolvers/checkoutState';
 */
export const clearRxCheckoutState = ( ) => {

    return store.dispatch( clearCheckoutState() );
};

/**
 * get the rxid's from the checkout state
 * import { getCheckoutState } from 'resolvers/checkoutState';
 */
export const getCheckoutState = ( ) => {

    // get ongoing call info from the redux store
    const memberId = get( store.getState()[ REDUCER.CHECKOUT_STATE ], 'memberId', [] );
    const rxIds = get( store.getState()[ REDUCER.CHECKOUT_STATE ], 'rxIds', [] );

    return { memberId, rxIds };
};


